/** @format */
import React, { FC, useState } from 'react'
import MonitorCrumb from 'src/components/MonitorCrumb'
import { _$, Card, BreadcrumbItem } from '@king-design/react'
import TacticsList from 'src/containers/MonitorHistoryTactics/TacticsList'
import { MonitorSearch, QuickRangeDate } from 'src/components'
import styled from 'styled-components'
import dayjs from 'dayjs'
import { useParams } from 'react-router'

interface OwnProps {
  className?: string
}

const TacticsDetail: FC<OwnProps> = ({ className }) => {
  const params = useParams<{ policyId: string; policyName: string }>()
  const [searchVal, setSearchVal] = useState('')
  const [dateTime, setDateTime] = useState({
    StartTime: dayjs().subtract(1, 'h').unix(),
    EndTime: dayjs().unix()
  })
  return (
    <div className={className}>
      <MonitorCrumb
        breadArr={[
          { title: _$('告警服务') },
          { title: _$('告警历史'), route: '/monitor/alarmServer/history/home' }
        ]}
      >
        <BreadcrumbItem>{decodeURIComponent(params.policyName)}</BreadcrumbItem>
      </MonitorCrumb>
      <Card>
        <div className="search-content">
          <QuickRangeDate
            format="YYYY-MM-DD HH:mm"
            // eslint-disable-next-line no-restricted-syntax -- QuickRangeDate 与组件约定的默认范围
            defautlValue={'近1小时'}
            // eslint-disable-next-line no-restricted-syntax -- QuickRangeDate 与组件约定的默认范围
            quickRange={['近1小时', '近1天', '近3天', '近1周']}
            optionalDateRange={30}
            changeValue={date => {
              setDateTime({
                StartTime: dayjs(date[0]).unix(),
                EndTime: dayjs(date[1]).unix()
              })
            }}
          />
          <MonitorSearch placeholder={_$('输入实例ID')} onChange={search => setSearchVal(search)} />
        </div>
        <TacticsList
          region="all"
          queryType="InstanceId"
          dateTime={dateTime}
          query={searchVal}
          policyName={decodeURIComponent(params?.policyName)}
          policyId={decodeURIComponent(params?.policyId)}
        />
      </Card>
    </div>
  )
}

export default styled(TacticsDetail)`
  .search-content {
    display: flex;
    justify-content: space-between;
  }
`
